<template>
  <div class="autocomplete-input">
    <input
      class="input is-large"
      :placeholder="!!placeholder ? placeholder : 'Search...'"
      @input="onInput($event.target.value)"
      @keyup.esc="isOpen = false"
      @blur="isOpen = false"
      @keydown.down="moveDown"
      @keydown.up="moveUp"
      @keydown.enter="select"      
    >
  
    <ul class="options-list" v-show="isOpen">
      <li v-for="(option, index) in options" :class="{'highlighted': index === highlightedPosition}"
        @mouseenter="highlightedPosition = index"
        @mousedown="select(option)">
        <slot name="item"
          :title="option.firstname + ' ' + option.lastname"
          :remark="option.map"
          :subtitle="option.country_name"
          :description="option.lastname"
          :thumbnail="option.img_path"
          :dojoTitle="option.dojo"
        />
      </li>
    </ul>
  </div>
</template>

<style>
  .autocomplete-input { }
  .autocomplete-input input { margin: 0; }
  .autocomplete-input-item { display: flex; align-items: center; cursor: pointer; }
  .autocomplete-input .options-list { background: #fff; padding: 0; list-style: none; margin: 0; border-top: 1px solid #ccc; max-height: 300px; overflow-y: scroll; position: relative; z-index: 1; }
  .autocomplete-input .options-list li { padding: 10px; border-bottom: 1px solid #ccc; }
  .autocomplete-input .options-list li.highlighted { background-color: #f2f2f2; }
  .autocomplete-input-item-image-outer { width: 40px; height: 40px; overflow: hidden; border-radius: 50%; margin-right: 10px; }
  .autocomplete-input-item-image-outer img { width: 40px; margin-top: -20%;  }  
</style>

<script>

export default {
  name: 'autocomplete-input',
  props: {
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isOpen: false,
      highlightedPosition: 0,
      keyword: ''
    }
  },
  computed: {
    // not needed here, all ajax
    filteredOptions () {
      const re = new RegExp(this.keyword, 'i')
      return this.options.filter(o => o.firstname.match(re))
    }
  },
  methods: {
    onInput (value) {
      // alert(value)
      this.keyword = value
      this.$emit('input', this.keyword)
      this.isOpen = !!value
      this.highlightedPosition = 0
    },
    moveDown () {
      if (!this.isOpen) {
        return
      }
      this.highlightedPosition = (this.highlightedPosition + 1) % this.filteredOptions.length
    },
    moveUp () {
      if (!this.isOpen) {
        return
      }
      this.highlightedPosition = this.highlightedPosition - 1 < 0
        ? this.filteredOptions.length - 1
        : this.highlightedPosition - 1
    },
    select (option) {
      const selectedOption = option // this.filteredOptions[this.highlightedPosition]
      console.log('internal selectedOption' + selectedOption)
      // this.keyword = selectedOption.title
      this.isOpen = false
      this.$emit('select', selectedOption)
    }
  },
  watch: {
    keyword: function (val) {
      /*
      this.$emit('input', val)
      this.isOpen = !!val
      this.highlightedPosition = 0
      */
    }
  }
}
</script>
